import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { LocalizedSectionTitle } from '@mews-commander/ui';
import { Button, IconName, Stack } from '@optimus-web/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { isInMonthMode } from '../../../selectors';
import { useAvailabilityBlockInfo } from '../../../utils/useAvailabilityBlockInfo';
import MonthSelector from './MonthSelector';

interface HeaderProps {
    availabilityBlockId: string;
    handleAdjustButtonClick: () => void;
    serviceId: string;
    isEditMode: boolean;
}

export const Header = ({ serviceId, availabilityBlockId, isEditMode, handleAdjustButtonClick }: HeaderProps) => {
    const { availabilityBlock } = useAvailabilityBlockInfo(availabilityBlockId);

    const isMonthMode = useCommanderSelector((state) => isInMonthMode(state, { id: availabilityBlockId, serviceId }));

    if (!availabilityBlock) {
        return null;
    }

    return (
        <Stack
            distribution="space-between"
            spacing="100"
            largePhoneMax={{
                vertical: isMonthMode,
            }}
        >
            <LocalizedSectionTitle textKey={TextKey.Settings} />
            <Stack itemAlignment="center" alignment="end" spacing="100">
                {isMonthMode && <MonthSelector id={availabilityBlockId} />}
                {!isEditMode && (
                    <Button onClick={handleAdjustButtonClick} icon={IconName.Edit} data-test-ab-adjust type="submit">
                        <LocalizedText textKey={TextKey.Adjust} />
                    </Button>
                )}
            </Stack>
        </Stack>
    );
};
